<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import personMap from '$routes/(public)/(people)/personMap';

	const youCanBookMeDomain = personMap.get('tyler-johnson').calendar.domain;
</script>

<Section>
	<p>
		Schedule an appointment on the calendar below or contact us at <a
			href="mailto:commercial@indowwindows.com">commercial@indowwindows.com</a
		> / 503-505-6380.
	</p>
	<div
		class="
    col-span-full! w-full
    max-md:-mb-5
  "
	>
		<script
			src="https://embed.ycb.me"
			async="true"
			data-autoscroll
			data-domain={youCanBookMeDomain}
		></script>
	</div>
</Section>
<Reviews />
